import React, { useState } from 'react';
import { 
  MDBBtn, 
  MDBCheckbox
} from 'mdb-react-ui-kit';
import { useTranslation } from 'react-i18next';

export default function TermsStep({ onComplete, stepId, isCompleted }) {
  const { t } = useTranslation();
  const [termsAccepted, setTermsAccepted] = useState(false);
  const isValid = termsAccepted;

  const handleComplete = () => {
    if (isValid) {
      console.log('Terms accepted:', {
        terms: termsAccepted,
        timestamp: new Date().toISOString()
      });
      onComplete(stepId);
    }
  };

  return (
    <div className="h-100 d-flex flex-column">
      <div className="mb-4">
        <h3>{t('General Consent for Use of Provided Content')}</h3>
        <p className="text-muted">
          {t('Please read the following conditions carefully and confirm them.')}
        </p>
      </div>

      <div className="flex-grow-1 mb-4">
        <div className="terms-content mb-4" style={{ lineHeight: '1.7', fontSize: '0.95rem' }}>
          <p className="mb-3">
            {t(`By entering information on "Cleanroom Processes", you agree that the content provided by you / your company – in particular photos, names, company names, presentation titles and descriptions as well as other texts – may be used and published as follows within the framework of the public relations work of the Cleanroom Processes platform, the Lounges and the CP-Academy:`)}
          </p>

          <div className="mb-3">
            <strong>{t('The content may be used as follows:')}</strong>
            <ul className="mt-2">
              <li>{t('Online presence: Publication on the Cleanroom Processes website and in the official Cleanroom Processes app')}</li>
              <li>{t('Social Media: Publication on Cleanroom Processes social media channels, especially on LinkedIn')}</li>
              <li>{t('Newsletter: Use in digital newsletters from Cleanroom Processes')}</li>
              <li>{t('Print media: Publication in the official event program of LOUNGES and the Cleanroom Processes platform (print and digital)')}</li>
              <li>{t('Press work: Use in press releases and press articles about the Cleanroom Processes platform')}</li>
            </ul>
          </div>

          <p className="mb-3">
            {t('The use is exclusively in connection with the promotion and reporting on the respective event and the Cleanroom Processes platform. Data is only passed on to third parties within the scope of the stated purposes (e.g. to press representatives).')}
          </p>

          <p className="mb-4">
            {t('You assure that you are authorized to pass on and use the submitted content and that no third party rights are violated by the publication.')}
          </p>
        </div>

        <div className="d-flex align-items-start mb-3">
          <MDBCheckbox
            id="terms-checkbox"
            checked={termsAccepted}
            onChange={(e) => setTermsAccepted(e.target.checked)}
            className="me-3 mt-1"
          />
          <label htmlFor="terms-checkbox" className="form-check-label">
            <strong>{t('I have read the information on the use of submitted content and agree to the described use.')}</strong>
          </label>
        </div>

        {!isValid && (
          <div className="alert alert-warning" role="alert">
            <small>
              {t('Please accept the consent for the use of provided content to continue.')}
            </small>
          </div>
        )}
      </div>

      <div className="mt-4 d-flex justify-content-between">
        <div></div>
        <MDBBtn 
          color="success" 
          size="lg"
          onClick={handleComplete}
          disabled={!isValid}
          className="px-4"
        >
          {t('Complete Onboarding')}
        </MDBBtn>
      </div>
    </div>
  );
}